import { FormGroup, Input, Label } from "reactstrap";

interface Props {
  value: string;
  isActive: boolean;
  setIsActive: (isActive: boolean) => void;
  valueToLabelMapper?: (value: string) => string;
}

export function Switcher({
  value,
  isActive,
  setIsActive,
  valueToLabelMapper = (v: string) => v,
}: Props) {
  function toggle() {
    setIsActive(!isActive);
  }

  return (
    <FormGroup switch>
      <Label>
        <Input
          type="switch"
          role="switch"
          checked={isActive}
          onChange={() => toggle()}
        />{" "}
        {valueToLabelMapper(value)}
      </Label>
    </FormGroup>
  );
}
